var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTailwindcss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 12.75C23.4667 12.75 18.1333 17.0167 16 25.55C19.2 21.2833 22.9333 19.6833 27.2 20.75C29.6344 21.3586 31.3743 23.1246 33.3003 25.0796C36.4377 28.2642 40.0689 31.95 48 31.95C56.5333 31.95 61.8667 27.6833 64 19.15C60.8 23.4167 57.0667 25.0167 52.8 23.95C50.3656 23.3414 48.6257 21.5754 46.6997 19.6204C43.5623 16.4358 39.9311 12.75 32 12.75ZM16 31.95C7.46667 31.95 2.13333 36.2167 0 44.75C3.2 40.4833 6.93333 38.8833 11.2 39.95C13.6344 40.5586 15.3743 42.3246 17.3003 44.2796C20.4377 47.4642 24.0689 51.15 32 51.15C40.5333 51.15 45.8667 46.8833 48 38.35C44.8 42.6167 41.0667 44.2167 36.8 43.15C34.3656 42.5414 32.6257 40.7754 30.6997 38.8204C27.5623 35.6358 23.9311 31.95 16 31.95Z",
    fill: "url(#paint0_linear_491_184)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_491_184",
    x1: -1.77778,
    y1: 25.038,
    x2: 53.4967,
    y2: 56.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2298BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ED7B5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindcss);
export default __webpack_public_path__ + "static/media/Tailwindcss.ac5a5f1139a23921290d17d84a02daad.svg";
export { ForwardRef as ReactComponent };